import { createDialogueQuery } from '../../../../../server-services/querys';
import { ResponseMergerType } from '../../cache-logic-interface';
import { customCreateDialogueMutationMerger } from './sub-merger/create-dialogue-mutation-merger';

export let customMutationMerger: ResponseMergerType = {
  default: function (cache, request, response) {},
  [createDialogueQuery.endpoint]: customCreateDialogueMutationMerger,
};
